// extracted by mini-css-extract-plugin
export default {"wrapper":"HeadingWithDecoration_wrapper__m3i82","headingCursor":"HeadingWithDecoration_headingCursor__NeVpn","icon":"HeadingWithDecoration_icon__w4Y9n"};